var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMcq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8617 3.90577L10.2251 1.41141C9.94466 1.1461 9.5776 1 9.19156 1H4.17188C3.34262 1 2.66797 1.67465 2.66797 2.50391V13.4961C2.66797 14.3253 3.34262 15 4.17188 15H11.8281C12.6574 15 13.332 14.3253 13.332 13.4961V4.99826C13.332 4.58676 13.1606 4.18855 12.8617 3.90577ZM12.0649 4.28125H10.0234C9.94805 4.28125 9.88672 4.21992 9.88672 4.14453V2.22052L12.0649 4.28125ZM11.8281 14.1797H4.17188C3.79494 14.1797 3.48828 13.873 3.48828 13.4961V2.50391C3.48828 2.12697 3.79494 1.82031 4.17188 1.82031H9.06641V4.14453C9.06641 4.67224 9.49573 5.10156 10.0234 5.10156H12.5117V13.4961C12.5117 13.873 12.2051 14.1797 11.8281 14.1797Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9258 6.46875H4.91016C4.68364 6.46875 4.5 6.65239 4.5 6.87891C4.5 7.10542 4.68364 7.28906 4.91016 7.28906H10.9258C11.1523 7.28906 11.3359 7.10542 11.3359 6.87891C11.3359 6.65239 11.1523 6.46875 10.9258 6.46875ZM10.9258 8.65625H4.91016C4.68364 8.65625 4.5 8.83989 4.5 9.06641C4.5 9.29292 4.68364 9.47656 4.91016 9.47656H10.9258C11.1523 9.47656 11.3359 9.29292 11.3359 9.06641C11.3359 8.83989 11.1523 8.65625 10.9258 8.65625ZM6.89859 10.8438H4.91016C4.68364 10.8438 4.5 11.0274 4.5 11.2539C4.5 11.4804 4.68364 11.6641 4.91016 11.6641H6.89859C7.12511 11.6641 7.30875 11.4804 7.30875 11.2539C7.30875 11.0274 7.12511 10.8438 6.89859 10.8438Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcq);
export default __webpack_public_path__ + "static/media/MCQ.4b87b01f47d320af30638fead73c8fe4.svg";
export { ForwardRef as ReactComponent };